import { EffectCallback, useEffect } from 'react'

/**
 * Hook that runs the effect only once on mount
 *
 * @param effect - The effect to run
 */
export const useOnMount = (effect: EffectCallback) => {
	useEffect(effect, [])
}
